module.exports = __webpack_public_path__ + "fonts/element-icons.9b70ee41.woff";